// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ichalEntity from './entities/ichal.json';
import ichalMenu from '../pages/ichal/menu.json';
import ichalFullForm from '../pages/ichal/forms/full.json';
import ichalContextForm from '../pages/ichal/forms/context.json';
import ichalMiniForm from '../pages/ichal/forms/mini.json';
import ichalLookupForm from '../pages/ichal/forms/lookup.json';
import ichalTableView from '../pages/ichal/views/table.json';
import ichalStagesView from '../pages/ichal/views/stages.json';
import ichalCardsView from '../pages/ichal/views/cards.json';
import ichalInlineView from '../pages/ichal/views/inline.json';
import ichalBacklogView from '../pages/ichal/views/backlog.json';
import ichalSplitView from '../pages/ichal/views/split.json';
import ichalCalendarView from '../pages/ichal/views/calendar.json';
import ichalDashboardView from '../pages/ichal/views/dashboard.json';

/** Тип запису «Виклик для ідей» зі сторінками пакета: меню, форми та подання з pages/ichal/. */
export const ichalDefinition: IRecordTypeDefinition = {
  ...ichalEntity,
  views: assembleViewSet({
      table: ichalTableView,
      stages: ichalStagesView,
      cards: ichalCardsView,
      inline: ichalInlineView,
      backlog: ichalBacklogView,
      split: ichalSplitView,
      calendar: ichalCalendarView,
      dashboard: ichalDashboardView,
  }),
  form: ichalFullForm,
  forms: { full: ichalFullForm, context: ichalContextForm, mini: ichalMiniForm, lookup: ichalLookupForm },
  menu: ichalMenu,
} as IRecordTypeDefinition;
